import moment from "moment"

export const hideAttendance = (end_date, end_time) => {
  const userType = localStorage.getItem("userType")
  if (userType === "superadmin") return false

  const now = moment()
  const today = now.clone().startOf("day")
  const endDate = moment(end_date, "DD-MM-YYYY").startOf("day")
  const endDateTime = moment(`${end_date} ${end_time}`, "DD-MM-YYYY h:mm A")

  // If end date is in the future → show button
  if (endDate.isAfter(today)) {
    return false
  }

  // If end date is today
  if (endDate.isSame(today)) {
    // If current time is before end time → show button
    if (now.isBefore(endDateTime)) {
      return false
    }

    // If less than 30 minutes have passed since end time → show button
    const diffInMinutes = now.diff(endDateTime, "minutes")
    if (diffInMinutes <= 30) {
      return false
    }
  }

  // Else: date is before today or 30+ minutes passed after today's end time → hide button
  return true
}
